import { render, staticRenderFns } from "./BodyView.vue?vue&type=template&id=5369ee72&scoped=true&"
import script from "./BodyView.vue?vue&type=script&lang=js&"
export * from "./BodyView.vue?vue&type=script&lang=js&"
import style0 from "./BodyView.vue?vue&type=style&index=0&id=5369ee72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5369ee72",
  null
  
)

export default component.exports